webpackJsonp([3],{

/***/ 5004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_work__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_theme__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Blom__ = __webpack_require__(5061);
var mapStateToProps=function mapStateToProps(state){return{blom:state.work.blom,next:state.work.unionSquare,prev:state.work.sketches,theme:state.theme};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{load:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_2__actions_work__["a" /* default */].fetch,dispatch),loadTheme:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_3__actions_theme__["a" /* default */].fetch,dispatch)};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__pages_Blom__["a" /* default */]));

/***/ }),

/***/ 5012:
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(5027);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),

/***/ 5013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorkNav__ = __webpack_require__(5014);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WorkNav__["a"]; });


/***/ }),

/***/ 5014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(5015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(23);
var WorkTile=function WorkTile(_ref){var work=_ref.work;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],Object.assign({to:work.link},__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* halfWidth */],__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* fullWidthSm */],__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* relative */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Image__["a" /* default */],{sources:work.headerImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* center */],__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* linkStyles */],__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* workTitleWrapper */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',__WEBPACK_IMPORTED_MODULE_3__styles__["g" /* workTitle */],work.title)));};var WorkNav=function WorkNav(_ref2){var prev=_ref2.prev,next=_ref2.next;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* relative */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* anchorTopLg */],__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* noPointer */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',Object.assign({},__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* header */],__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* noPointer */]),'Other projects'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* absolute */],__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* hideOnSm */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'100%',height:'50%',viewBox:'0 0 100 50',xmlns:'http://www.w3.org/2000/svg',align:'xMaxYMax'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'0,0 100,0 50,50, 0,0',fill:'#fff'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_4__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkTile,{work:prev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkTile,{work:next})));};/* harmony default export */ __webpack_exports__["a"] = (WorkNav);

/***/ }),

/***/ 5015:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return relative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return absolute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return anchorTopLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return noPointer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return linkStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return workTitleWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return workTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_typography__ = __webpack_require__(36);
var relative=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'relative'});var absolute=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'absolute',width:'100%',top:0,left:0,zIndex:1});var anchorTopLg=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({'@media(min-width: 48em)':{position:'absolute',width:'50%',top:0,left:'50%',transform:'translate(-50%)',zIndex:1}});var header=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'relative',margin:__WEBPACK_IMPORTED_MODULE_1__utils_typography__["a" /* default */].rhythm(2)+' 0',color:'rgba(0, 0, 0, 0.8)',zIndex:2,textAlign:'center',textTransform:'uppercase'});var noPointer=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({pointerEvents:'none'});var linkStyles=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({color:'rgba(0, 0, 0, 0.8)',backgroundImage:'none',textShadow:'none','@media(max-width: 48em)':{color:'white'}});var workTitleWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'absolute',padding:__WEBPACK_IMPORTED_MODULE_1__utils_typography__["a" /* default */].rhythm(1),top:'50%',left:'50%',transform:'translate(-50%)',border:'1px solid white'});var workTitle=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({margin:0,color:'white'});

/***/ }),

/***/ 5016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(5017);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader__["a"]; });


/***/ }),

/***/ 5017:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(5018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loader=function(_React$Component){_inherits(Loader,_React$Component);function Loader(){_classCallCheck(this,Loader);return _possibleConstructorReturn(this,(Loader.__proto__||Object.getPrototypeOf(Loader)).apply(this,arguments));}_createClass(Loader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* wrapper */],__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* center */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Loading'));}}]);return Loader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),

/***/ 5018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glamor__);
var wrapper=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'fixed',display:'flex',justifyContent:'center',alignItems:'center',top:0,left:0,width:'100%',height:'100vh',zIndex:101,background:'white'});

/***/ }),

/***/ 5019:
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(5033),
    keys = __webpack_require__(110);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 5020:
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(2059),
    isArrayLike = __webpack_require__(108),
    isIndex = __webpack_require__(2060),
    isObject = __webpack_require__(106);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 5021:
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(5025);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 5022:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),

/***/ 5023:
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 5025:
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(5026);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 5026:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(106),
    isSymbol = __webpack_require__(109);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 5027:
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),

/***/ 5030:
/***/ (function(module, exports, __webpack_require__) {

var arraySampleSize = __webpack_require__(5031),
    baseSampleSize = __webpack_require__(5032),
    isArray = __webpack_require__(24),
    isIterateeCall = __webpack_require__(5020),
    toInteger = __webpack_require__(5021);

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
  return func(collection, n);
}

module.exports = sampleSize;


/***/ }),

/***/ 5031:
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(5022),
    copyArray = __webpack_require__(5023),
    shuffleSelf = __webpack_require__(5012);

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

module.exports = arraySampleSize;


/***/ }),

/***/ 5032:
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(5022),
    shuffleSelf = __webpack_require__(5012),
    values = __webpack_require__(5019);

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

module.exports = baseSampleSize;


/***/ }),

/***/ 5033:
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(2062);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 5034:
/***/ (function(module, exports, __webpack_require__) {

var arrayShuffle = __webpack_require__(5035),
    baseShuffle = __webpack_require__(5036),
    isArray = __webpack_require__(24);

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

module.exports = shuffle;


/***/ }),

/***/ 5035:
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(5023),
    shuffleSelf = __webpack_require__(5012);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),

/***/ 5036:
/***/ (function(module, exports, __webpack_require__) {

var shuffleSelf = __webpack_require__(5012),
    values = __webpack_require__(5019);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

module.exports = baseShuffle;


/***/ }),

/***/ 5037:
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(5038),
    isIterateeCall = __webpack_require__(5020),
    toInteger = __webpack_require__(5021);

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),

/***/ 5038:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 5061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sampleSize__ = __webpack_require__(5030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_sampleSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_sampleSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_shuffle__ = __webpack_require__(5034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_slice__ = __webpack_require__(5037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Image__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_WorkNav__ = __webpack_require__(5013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Loader__ = __webpack_require__(5016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Animated__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BigList__ = __webpack_require__(2063);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import range from 'lodash/range';
var row1=function row1(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_10__styles__["d" /* fullWidth */],{key:'image-'+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Image__["a" /* default */],{sources:image}));};var row2=function row2(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_10__styles__["f" /* halfWidth */],{key:'image-'+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Image__["a" /* default */],{sources:image}));};var row3=function row3(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_10__styles__["v" /* thirdWidth */],{key:'image-'+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Image__["a" /* default */],{sources:image}));};// const row4 = (image, index) => {
//   return (
//     <div {...quarterWidth} key={`image-${index}`}>
//       <Image sources={image} />
//     </div>
//   );
// };
var Blom=function(_Component){_inherits(Blom,_Component);function Blom(props){_classCallCheck(this,Blom);var _this=_possibleConstructorReturn(this,(Blom.__proto__||Object.getPrototypeOf(Blom)).call(this,props));_this.state={set1:[],set2:[]};return _this;}_createClass(Blom,[{key:'componentWillMount',value:function componentWillMount(){this.props.load();this.props.loadTheme();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.blom&&nextProps.blom.images&&!this.state.set1.length){var images=nextProps.blom.images;var set1=__WEBPACK_IMPORTED_MODULE_5_lodash_slice___default()(images,1,400);set1=__WEBPACK_IMPORTED_MODULE_3_lodash_sampleSize___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_shuffle___default()(set1),25);var set2=__WEBPACK_IMPORTED_MODULE_5_lodash_slice___default()(images,401,images.length-1);set2=__WEBPACK_IMPORTED_MODULE_3_lodash_sampleSize___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_shuffle___default()(set2),25);this.setState({set1:set1,set2:set2});// traiditional, fluidity, quarter-circle, and mountain
var traditionalSet=[4,5,7,9,12,18,26,27,29,33,34,37,38,40,44,50,56,61,65,66,67,83,90,91,92];var fluiditySet=[3,10,11,15,19,21,23,28,32,35,43,48,63,86,94,96,100];var qCircleSet=[13,20,31,51,54,59,60,87,95,97,104,115];var mountainSet=[16,39,41,47,84];var innvortisSet=[36,49,53,88,99];var skipsSet=[22,57,58,62,74,327,331,348,461,504];var swirlSet=[52,368,391];// const prideSet = [79];
var mirrorSet=[82,105,332,380,421,465];var monochromeSet=[2,102,310,528];var hueySet=[107,108,114,119];var quiltedSet=[122,125,128,129];var triangleSet=[299,303,308,319,321,322,323,338,339];var outlineSet=[309,330,352,355,376];// const squareSet = [311, 316, 328, 361];
var randomTraditionalIndex=Math.floor(Math.random()*traditionalSet.length);var randomTraditional=images[traditionalSet[randomTraditionalIndex]-1];var randomFluidityIndex=Math.floor(Math.random()*fluiditySet.length);var randomFluidity=images[fluiditySet[randomFluidityIndex]-1];var randomQCircleIndex=Math.floor(Math.random()*qCircleSet.length);var randomQCircle=images[qCircleSet[randomQCircleIndex]-1];var randomMountainIndex=Math.floor(Math.random()*mountainSet.length);var randomMountain=images[mountainSet[randomMountainIndex]-1];var randomInnvortisIndex=Math.floor(Math.random()*innvortisSet.length);var randomInnvortis=images[innvortisSet[randomInnvortisIndex]-1];var randomHueyIndex=Math.floor(Math.random()*hueySet.length);var randomHuey=images[hueySet[randomHueyIndex]-1];var randomMonochromeIndex=Math.floor(Math.random()*monochromeSet.length);var randomMonochrome=images[monochromeSet[randomMonochromeIndex]-1];var randomQuiltedIndex=Math.floor(Math.random()*quiltedSet.length);var randomQuilted=images[quiltedSet[randomQuiltedIndex]-1];// const randomPrideIndex = Math.floor(Math.random() * prideSet.length);
// const randomPride = images[prideSet[randomPrideIndex] - 1];
var randomSwirlIndex=Math.floor(Math.random()*swirlSet.length);var randomSwirl=images[swirlSet[randomSwirlIndex]-1];var randomMirrorIndex=Math.floor(Math.random()*mirrorSet.length);var randomMirror=images[mirrorSet[randomMirrorIndex]-1];var randomSkipsIndex=Math.floor(Math.random()*skipsSet.length);var randomSkips=images[skipsSet[randomSkipsIndex]-1];var randomTriangleIndex=Math.floor(Math.random()*triangleSet.length);var randomTriangle=images[triangleSet[randomTriangleIndex]-1];var randomOutlineIndex=Math.floor(Math.random()*outlineSet.length);var randomOutline=images[outlineSet[randomOutlineIndex]-1];// const randomSquareIndex = Math.floor(Math.random() * squareSet.length);
// const randomSquare = images[squareSet[randomSquareIndex] - 1];
var colorsList={huey:{title:'Huey',slug:'huey',excerpt:'The huey color theme selects a random hue and modulates the color over time.',headerImage:randomHuey,images:[randomHueyIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},monochrome:{title:'Monochromatic',slug:'monochromatic',excerpt:'Sometimes the Huey theme will have a very small threshold of color variation, creating a monochrome image.',headerImage:randomMonochrome,images:[randomMonochromeIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},quilted:{title:'Quilted',slug:'quilted',excerpt:'The quilted color theme assigns random colors to each particle from a collection of predefined sets.',headerImage:randomQuilted,images:[randomQuiltedIndex],colorTheme:{base:'#121212',hilite:'#df0000'}}// pride: {
//   title: 'Pride',
//   slug: 'pride',
//   excerpt:
//     'In very rare cases, hues can cycle through the entire spectrum creating a beautiful rainbow.',
//   headerImage: randomPride,
//   images: [randomPrideIndex],
//   colorTheme: { base: '#121212', hilite: '#df0000' },
// },
};var presetsList={traditional:{title:'Traditional',slug:'traditional',excerpt:'The classic Blóm.',headerImage:randomTraditional,images:[randomTraditionalIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},fluidity:{title:'Fluidity',slug:'fluidity',excerpt:'Fluidity is similar to Traditional, but the Blóm is drawn with the lines going out from the center instead of around the center.',headerImage:randomFluidity,images:[randomFluidityIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},mountain:{title:'Mountain',slug:'mountain',excerpt:'Mountains are Blóms that are drawn from the side. The center of a Blóm is the top of the image, and it grows down and out along the canvas.',headerImage:randomMountain,images:[randomMountainIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},qCircle:{title:'Quarter Circle',slug:'qCircle',excerpt:'Quarter circle is a Blóm zoomed in on the bottom right quadrant.',headerImage:randomQCircle,images:[randomQCircleIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},innvortis:{title:'Innvortis',slug:'innvorits',excerpt:'Innvortis is a zoomed in Blóm, as if you are looking closely at it.',headerImage:randomInnvortis,images:[randomInnvortisIndex],colorTheme:{base:'#121212',hilite:'#df0000'}}};var renderersList={triangles:{title:'Triangles',slug:'triangles',excerpt:'Drawing triangles between particles and their neighbors yields visually interesting results.',headerImage:randomTriangle,images:[randomTriangleIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},outlines:{title:'Outlines',slug:'outlines',excerpt:'Shapes can be outlined, and the outline thickness can either be variable or static.',headerImage:randomOutline,images:[randomOutlineIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},swirls:{title:'Swirls',slug:'swirls',excerpt:'Particles can be drawn in a continuous line, creating pleasant-looking lines that appear hand-drawn.',headerImage:randomSwirl,images:[randomSwirlIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},skips:{title:'Skips',slug:'skips',excerpt:'Particles can be occasionally not drawn, creating negative space in the rendering.',headerImage:randomSkips,images:[randomSkipsIndex],colorTheme:{base:'#121212',hilite:'#df0000'}},mirror:{title:'Mirror',slug:'mirror',excerpt:'When the forces on a Blóm prevent it from filling the canvas, the Blóm is repeated in a circle around the original shape.',headerImage:randomMirror,images:[randomMirrorIndex],colorTheme:{base:'#121212',hilite:'#df0000'}}};this.setState({randomTraditional:randomTraditional,randomTraditionalIndex:randomTraditionalIndex,randomFluidity:randomFluidity,randomFluidityIndex:randomFluidityIndex,randomQCircleIndex:randomQCircleIndex,randomQCircle:randomQCircle,randomMountainIndex:randomMountainIndex,randomMountain:randomMountain,randomInnvortisIndex:randomInnvortisIndex,randomInnvortis:randomInnvortis,randomHueyIndex:randomHueyIndex,randomHuey:randomHuey,randomQuilted:randomQuilted,randomQuiltedIndex:randomQuiltedIndex,randomMonochrome:randomMonochrome,randomMonochromeIndex:randomMonochromeIndex,colorsList:colorsList,presetsList:presetsList,renderersList:renderersList});}}},{key:'render',value:function render(){var blom=this.props.blom;if(!blom||!blom.images){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Loader__["a" /* default */],null);}var allImages=blom.images;var _state=this.state,set1=_state.set1,set2=_state.set2,colorsList=_state.colorsList,presetsList=_state.presetsList,renderersList=_state.renderersList;var _props=this.props,prev=_props.prev,next=_props.next;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,{title:'Bl\xF3m by lucastswick',description:'Bl\xF3m is a generative art series that draws abstract roses.',meta:[{property:'og:image:url',content:'https://generativeartist.com'+allImages[0][2].srcSet},{property:'twitter:image',content:'https://generativeartist.com'+allImages[0][2].srcSet}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Bl\xF3m'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{delay:150},'Bl\xF3m is a generative art series that explores the tension between internal and external forces.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{delay:300},'Bl\xF3m is composed of many particles that all have intent - they want to move a certain direction - but external forces push them around. Sometimes the particles continue on their desired journey, sometimes they are forced onto another path, and these wanderings, over time, compose images.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{delay:450},'Released on the now-defunct platform gen.art, the series is long-form generative, meaning a piece is not created until someone purchases it. At that moment, a one-of-a-kind artwork is generated based on the unique signature of the buyer. Although I wrote the algorithm, no one, not even me, knows exactly what my algorithm will produce.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["j" /* imageWrapper */],row1(allImages[0],0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'Above is the very first image that was minted. Minting is the process of a buyer purchasing a single piece of the series. When the transaction occurs, a unique token is passed to my algorithm which then creates the one-of-a-kind art.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'Roughly 1000 pieces have been minted so far, and I\'m very pleased to see the variety of the collection and the reaction from the community.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'Here is a randomly selected sampling of images (you can refresh to see another set):')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(set1,function(image,index){if(index%5===0){var image2=set1[index+1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'group-'+index},row2(image,index),row2(image2,index+1));}else if(index%5===1){return null;}else{return row3(image,index);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'How was Bl\xF3m created?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'The first iteration of Bl\xF3m was created for a generative artist trading card series released in 2015. At the time, javascript was not performant enough to render high-resolution images in the browser, so I used',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'nofollow noopener noreferrer',href:'https://openframeworks.cc'},'openframeworks'),' ','to generate the 150 pieces of work that I eventually released as a limited print series.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'With the advent of NFTs, generative art suddenly became quite popular, and I was eager to revisit the project with all the new ideas and learnings I\'ve had in the past 6 years. Specifically, I focused on opportunities around color, perspective, and render methods.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Colors'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'The colors are either ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'quilted'),' or ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',null,'huey'),'. Quilted indicates each particle has a color selected from a list of preset color families. Huey means a random hue is chosen, and each particle\'s color can be modulated towards another hue over the course of the drawing.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_BigList__["a" /* default */],{items:colorsList})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Perspectives'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'In addition to lots of color variation, Bl\xF3ms can also be drawn from different perspectives.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_BigList__["a" /* default */],{items:presetsList})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Render Methods'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'The final component of creating variation within the collection is the employment of render methods, which change how each particle\'s path is drawn.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_BigList__["a" /* default */],{items:renderersList})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Even more Bl\xF3ms!')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(set2,function(image,index){if(index%5===0){var image2=set2[index+1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:'group-'+index},row2(image,index),row2(image2,index+1));}else if(index%5===1){return null;}else{return row3(image,index);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_10__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Reactions'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'Bl\xF3m has received amazing feedback from the community, particularly on twitter and the gen.art discord. Thank you to everyone who has supported the project, shared it, and even',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'nofollow noopener noreferrer',href:'https://twitter.com/liz_fitzg/status/1447314841895518210?s=20'},'made it their profile pic'),'!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'Technical Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'Bl\xF3m is written in javascript with zero dependencies, meaning as long as the etherium blockchain is running the work will be available. It\'s probably the first project I\'ve ever worked on that would still operate even if Amazon went down.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],{as:'h2'},'I\'d like one too please'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Animated__["a" /* default */],null,'Want your very own Bl\xF3m? You\'ll need a',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'nofollow noopener noreferrer',href:'https://gen.art'},'gen.art'),' ','membership, or you can buy existing pieces on',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'nofollow noopener noreferrer',href:'https://opensea.io/collection/gen-art-drop?search[sortAscending]=false&search[sortBy]=LAST_SALE_PRICE&search[stringTraits][0][name]=Artist&search[stringTraits][0][values][0]=lucastswick'},'OpenSea'),'.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_WorkNav__["a" /* default */],{prev:prev,next:next}));}}]);return Blom;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Blom);

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.ce3a03bb.chunk.js